export default __webpack_public_path__ + "static/uipath-latest-logo-new-371390b993459e14c74333c9f40139b3.svg";